<template lang='pug' src='./LoginKo.pug'></template>

<script>
  import GoogleBtn from '../../components/GoogleBtn/GoogleBtn'

  export default {
    name: 'LoginKo',
    components: {
      GoogleBtn
    }
  }
</script>

<style lang='css' src='./LoginKo.css'></style>



// WEBPACK FOOTER //
// LoginKo.vue?03b77cc8